// Public - Marketing - Homepage - Homepage Podcast Submit - Success View - Default Success View
// ----------------------
import React, { 
  //useState,
} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectPodcastSubmit, resetActiveViewForm } from '../podcastSubmitSlice'

import { motion } from "framer-motion";

import {
  Card,
  //Header,
  Image,
  Button,
} from 'semantic-ui-react';


export default function DefaultSuccessView() {
  const dispatch = useDispatch();
  const { podcastFollows, } = useSelector(selectPodcastSubmit);

  const list = {
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 1.5,
        staggerChildren: 0.1,
      },
    },
    hidden: {
      opacity: 0,
    },
  };
  const item = {
    visible: { opacity: 1, x: 0 },
    hidden: { opacity: 0, x: -10 },
  };

  return (
    <>
      <Card fluid className={'branded'}>
        <Card.Content textAlign={'center'} className={'card-main-content submission-success'}>
          <div> 
            <Card.Header>Your Podcasts Are Followed!</Card.Header>
            {!podcastFollows.loading && !podcastFollows.error && podcastFollows.followsAdded && podcastFollows.followsAdded.length !== 0 ?
              <Card.Description className={'podcast-album'}>
                <motion.ul
                  className="container"
                  variants={list}
                  initial="hidden"
                  animate="visible"
                >
                  {podcastFollows.followsAdded.map((podcast, index) => (
                    <motion.li key={index} className="item" variants={item}
                      whileHover={{
                        // scale: 1.2,
                        marginRight: '5px',
                        transition: { ease: 'easeOut' },
                      }}
                    >
                      <Image src={podcast.image ? podcast.image : null} />
                    </motion.li>
                  ))}
                </motion.ul>
              </Card.Description>
            :
              null
            }
            <Card.Description>
              <p>Access your Podcast Following Library to start listening to your favorite Podcasts!</p>
            </Card.Description>
            
            <Card.Description className={'dashboard'}>
              <Button as={'a'} secondary fluid
                href={'https://www.iheart.com/your-library/podcasts/'}
                target={'_self'}
                aria-label={'Navigate to Your Podcast Library'}
                onClick={()=>{dispatch(resetActiveViewForm())}}
              >
                Your Podcast Library
              </Button>
            </Card.Description>
          </div>
        </Card.Content>
      </Card>
    </>
  )
}